// extracted by mini-css-extract-plugin
module.exports = {"circle":"CircularProgressBar_circle__e4qYk","progress_ring":"CircularProgressBar_progress_ring__1dGsC"};